module.exports = __webpack_public_path__ + "static/media/webix.8014b75e.svg";